import { diagnosesAddressNameFields, psychologicalTreatmentAddressNameFields } from 'constants/enums/people';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { hasYesOrNo, checkValue } from 'models/validate';
import { isPVQForm } from 'helpers/form';
import psychologicalTreatmentTypeValidator from '../shared/treatmentTypeValidator';
import { PsychologicalDiagnosesModel } from './types';
import psychologicalDiagnosisItemValidator from './validators/item';

const psychologicalDiagnosesValidator: ValidateJSModel<PsychologicalDiagnosesModel> = {
  Diagnosed: { presence: true, hasValue: { validator: hasYesOrNo } },

  DidNotConsult: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    if (checkValue(attributes?.Diagnosed, 'Yes')) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  InTreatment: (value, attributes) => {
    if (checkValue(attributes?.Diagnosed, 'Yes') && checkValue(attributes?.DidNotConsult, 'Yes')) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  DiagnosisList: (value, attributes, attributeName, options) => {
    if (checkValue(attributes?.Diagnosed, 'Yes')) {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, diagnosesAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }

      return { ...additionalValidation, presence: true, accordion: { validator: psychologicalDiagnosisItemValidator } };
    }
    return {};
  },

  TreatmentList: (value, attributes, attributeName, options) => {
    if (checkValue(attributes?.InTreatment, 'Yes')) {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, psychologicalTreatmentAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }

      return { ...additionalValidation, presence: true, accordion: { validator: psychologicalTreatmentTypeValidator } };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
  DidNotConsultComments: {},
  InTreatmentComments: {},
  InTreatmentSummaryComments: {},
};

export default psychologicalDiagnosesValidator;
